export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const NOTIFICATIONS_FETCHED_SUCCESS = 'NOTIFICATIONS_FETCHED_SUCCESS';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';

export const SELECT_NOTIFICATION = 'SELECT_NOTIFICATION';